import { render, staticRenderFns } from "./SelectBact.vue?vue&type=template&id=0bb971f8&scoped=true"
import script from "./SelectBact.vue?vue&type=script&lang=js"
export * from "./SelectBact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb971f8",
  null
  
)

export default component.exports